export const checkIfStringContainsSignificantChar = (str: string) => {
	return !!str.trim();
};
